import React from 'react'

export default function SkipLinkTarget() {
  return <div id="header-end" />
}
